import { ColorPickerProps } from './color-picker.types'
import styles from './color-picker.module.scss'
// import cl from 'classnames'
import { ColorPicker as CP, useColor } from 'react-color-palette'
import 'react-color-palette/lib/css/styles.css'
import { useEffect } from 'react'
import { Text1 } from '@touche-lts/panel-ui/dist'

const ColorPickerComponent = (props: ColorPickerProps) => {
  const { initialValue, onChange, height, width } = props
  const [color, setColor] = useColor('hex', initialValue || '#121212')

  useEffect(() => {
    if (!onChange) return
    onChange(color.hex)
  }, [color, onChange])

  return (
    <div className={styles.container}>
      <CP
        width={width || 456}
        height={height || 228}
        color={color}
        onChange={setColor}
        hideHSV
        hideRGB
        dark
      />
      <div className={styles.selectedColorContainer}>
        <div
          className={styles.colorCircle}
          style={{ backgroundColor: color.hex }}
        />
        <Text1 colorPreset='dark'>Selected color</Text1>
      </div>
    </div>
  )
}

const ColorPicker = ColorPickerComponent
export { ColorPicker }
